/**
 * @generated SignedSource<<8af500b4a24552236a2e2bec6050bebb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PublishReminderDialog_folderItem$data = {
  readonly canRename: {
    readonly value: boolean;
  };
  readonly content: {
    readonly __typename: "Form";
    readonly id: string;
  } | {
    readonly __typename: "Page";
    readonly id: string;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  };
  readonly id: string;
  readonly name: string;
  readonly " $fragmentSpreads": FragmentRefs<"PublishFolderItemDialog_folderItem">;
  readonly " $fragmentType": "PublishReminderDialog_folderItem";
};
export type PublishReminderDialog_folderItem$key = {
  readonly " $data"?: PublishReminderDialog_folderItem$data;
  readonly " $fragmentSpreads": FragmentRefs<"PublishReminderDialog_folderItem">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = [
  (v0/*: any*/)
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PublishReminderDialog_folderItem",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "AuthorizationResult",
      "kind": "LinkedField",
      "name": "canRename",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "value",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "content",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "__typename",
          "storageKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": (v1/*: any*/),
          "type": "Page",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": (v1/*: any*/),
          "type": "Form",
          "abstractKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PublishFolderItemDialog_folderItem"
    }
  ],
  "type": "FolderItem",
  "abstractKey": null
};
})();

(node as any).hash = "d88bae54af36673b88fc58173c28a963";

export default node;
